import { QueryAPI } from "../api";

export const useSecurity = () => {
	// افزایش اعتبار کیف پول
	const increaseWalletByBankGateWay = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/IncreaseWalletByBankGateWay", parameters: parameters });
		return response ? response.Result : null;
	};

	//برگشت از بانک آسان پرداخت
	const callBackIPGAsanPardakht = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/CallBackIPGAsanPardakht", parameters: parameters });
		return response ? response : null;
	};
	//برگشت از بانک ملت
	const CallBackMellat = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/CallBackMellat", parameters: parameters });
		return response ? response : null;
	};
	//برگشت از بانک پارسیان
	const callBackIPGParsian = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/CallBackIPGParsian", parameters: parameters });
		return response ? response.Result : null;
	};
	// دریافت لیست درگاه ها
	const queryGateWayByPlanId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/QueryGateWayByPlanId", parameters: parameters });
		return response ? response.Result : null;
	};
	const callBackPOSAsanPardakht = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/CallBackPOSAsanPardakht", parameters: parameters });
		return response ? response : null;
	};

	return {
		increaseWalletByBankGateWay,
		callBackIPGAsanPardakht,
		callBackIPGParsian,
		queryGateWayByPlanId,
		callBackPOSAsanPardakht,
		CallBackMellat,
	};
};
